import type { QuestionDefinition } from "@reno-estimator/core";
import { booleanQuestion, builtInsQuestion, flooringQuestion, lightingQuestion, paintingQuestion, trimQuestion, windowsDoorsQuestion } from "./interior-room-shared.js";

/**
 * Primary Bedroom (Phase 13A) - see rules/primary-bedroom.ts for the
 * matching calculator. Kept as its own question set (not a reuse of
 * bedroom.ts) since a primary bedroom's real scope differs: a dedicated
 * closet-system tier and an optional sitting area, on top of the same
 * ensuite-rough-in option bedroom.ts offers.
 */
export const primaryBedroomQuestions: QuestionDefinition[] = [
  flooringQuestion("primary_bedroom", 200, "primary bedroom"),
  paintingQuestion("primary_bedroom", 210),
  trimQuestion("primary_bedroom", 220),
  lightingQuestion("primary_bedroom", 230),
  builtInsQuestion("primary_bedroom", 235, "Any additional built-in storage (beyond the closet system below)?", "Custom built-in storage"),
  windowsDoorsQuestion("primary_bedroom", 250, "Any window or door changes?"),
  {
    id: "primary_bedroom_closet_system",
    projectTypes: ["primary_bedroom"],
    inputType: "single_select",
    prompt: "What about the closet?",
    required: false,
    options: [
      { id: "none", label: "No change" },
      { id: "reach_in_upgrade", label: "Reach-in closet upgrade" },
      { id: "walk_in_system", label: "Full walk-in closet system" }
    ],
    order: 240
  },
  booleanQuestion("primary_bedroom_sitting_area", "primary_bedroom", "Adding a sitting area?", 260),
  booleanQuestion("primary_bedroom_ensuite_rough_in", "primary_bedroom", "Add plumbing rough-in for a future ensuite?", 270, "Rough plumbing only - not a full ensuite build-out.")
];
